'use client';

import { sessionStorageHelper } from '@core/Utils/SessionStorageHelper';
import { atom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';

export const finCalcInteractedWithAtom = atom<boolean>(false);

export const finCalcInteractedWithStorageAtom = atomWithStorage<boolean>(
  'finCalcInteractedWith',
  false,
  sessionStorageHelper as any,
);
